import { Box, Button, Grid, Flex, AutoRenewIcon, useMatchBreakpoints } from '@pancakeswap/uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import {
  useGetLeaderboardHasMoreResults,
  useGetLeaderboardLoadingState,
  useGetLeaderboardResults,
  useGetLeaderboardSkip,
} from 'state/predictions/hooks'
import { filterNextPageLeaderboard } from 'state/predictions'
import { LEADERBOARD_RESULTS_PER_PAGE } from 'state/predictions/helpers'
import { useTranslation } from '@pancakeswap/localization'
import Container from 'components/Layout/Container'
import { FetchStatus } from 'config/constants/types'
import styled from 'styled-components'
import DesktopResults from './DesktopResults'
import MobileResults from './MobileResults'
import RankingCard from './RankingCard'

const StyledButton = styled(Button)`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
  font-weight: 700;
  padding: 8px 16px;
  height: 40px;
  color: white;
  line-height: normal;
`
const StyleTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 16px;
  color: #fff;
`
const Results = () => {
  const { isDesktop } = useMatchBreakpoints()
  const { t } = useTranslation()
  const [first, second, third, ...rest] = useGetLeaderboardResults()
  const leaderboardLoadingState = useGetLeaderboardLoadingState()
  const isLoading = leaderboardLoadingState === FetchStatus.Fetching
  const currentSkip = useGetLeaderboardSkip()
  const hasMoreResults = useGetLeaderboardHasMoreResults()
  const dispatch = useLocalDispatch()

  const handleClick = () => {
    dispatch(filterNextPageLeaderboard(currentSkip + LEADERBOARD_RESULTS_PER_PAGE))
  }

  return (
    <Box>
      <StyleContainer mb="32px">
        {' '}
        <StyleTitle>Total Rankings</StyleTitle>
        <StyleGrid gridTemplateColumns={['1fr', null, null, null, null, 'repeat(3, 1fr)']}>
          {first && (
            <RankingCard
              rank={1}
              user={first}
              icon="/images/leaderboard/cup1.svg"
              bg="linear-gradient(0deg, #413302 0%, #1C1809 100%)"
            />
          )}
          {second && (
            <RankingCard
              rank={2}
              user={second}
              icon="/images/leaderboard/cup2.svg"
              bg="linear-gradient(180deg, #0A0D25 0%, #212870 100%)"
            />
          )}
          {third && (
            <RankingCard
              rank={3}
              user={third}
              icon="/images/leaderboard/cup3.svg"
              bg="                    linear-gradient(180deg, #011217 0%, #044A61 100%)"
            />
          )}
        </StyleGrid>
      </StyleContainer>
      {isDesktop ? <DesktopResults results={rest} /> : <MobileResults results={rest} />}
      <Flex paddingBottom="120px" justifyContent="center">
        {hasMoreResults && (
          <StyledButton variant="secondary" isLoading={isLoading} onClick={handleClick}>
            {isLoading ? t('Loading...') : t('View More')}
          </StyledButton>
        )}
      </Flex>
    </Box>
  )
}

const StyleGrid = styled(Grid)`
  gap: 24px;
`
const StyleContainer = styled(Container)`
  @media screen and (max-width: 700px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`
export default Results
